// ============================================================
// Versions des textes juridiques en vigueur
// ============================================================
// Chaque acceptation est enregistrée dans `legal_acceptances` avec la version
// affichée au moment où l'utilisateur a coché la case : c'est la preuve qu'il a
// accepté CE texte-là. Changer un texte publié = changer sa version ici, dans le
// même commit que le texte lui-même.
//
// Tant que les nouveaux textes (lot 2 du chantier conformité, voir
// docs/plans/2026-10-14-conformite-00-index.md) ne sont pas publiés, la version en
// vigueur est celle du document CGU/CGV du 20/03/2026.

export const LEGAL_DOCUMENTS = {
  CGU_JOUEUR: "cgu_joueur",
  POLITIQUE_CONFIDENTIALITE: "politique_confidentialite",
  CGV_PREMIUM: "cgv_premium",
  CONDITIONS_PRO: "conditions_pro",
} as const;

export type LegalDocument = (typeof LEGAL_DOCUMENTS)[keyof typeof LEGAL_DOCUMENTS];

export const LEGAL_VERSIONS: Record<LegalDocument, string> = {
  cgu_joueur: "2026-03-20",
  politique_confidentialite: "2026-03-20",
  cgv_premium: "2026-03-20",
  conditions_pro: "2026-03-20",
};

/**
 * Métadonnées passées à `supabase.auth.signUp` quand l'utilisateur a coché la
 * case d'acceptation. Le trigger `handle_new_user` les lit pour écrire les
 * lignes de `legal_acceptances` à la création du compte — avant même la
 * confirmation de l'email, moment où le navigateur n'a pas encore de session.
 */
export const signupLegalMetadata = () => ({
  cgu_joueur_version: LEGAL_VERSIONS.cgu_joueur,
  politique_confidentialite_version: LEGAL_VERSIONS.politique_confidentialite,
});

export const TERMS_CHECKBOX_ERROR = "Vous devez accepter les CGU";
